/* External */
import { useMemo } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router';

export default function useQuery() {
  const { search } = useLocation();
  return useMemo(() => queryString.parse(search), [search]);
}
